// ../Utils/message.js
export const Message = {
  reqPw: "Current password is required",
  newPwReq: "New password is required",
  pwLenth: "Password must be at least 8 characters long",
  pwPttrn: "Password must contain uppercase, lowercase, and number",
  newPwVal: "New password must be different from current password",
  confirmPwReq: "Please confirm your new password",
  pwNotMatch: "Passwords do not match",
  apiError: "Failed to change password. Please try again later.",
  pwReq:"Password is required"
};

